
import useDialogVisible from '@/hooks/use-dialog-visible';
import { ElMessage, ElForm } from 'element-plus';
import { UserItem } from '@/api/auth-manage/user/type.d';
import { useFuzzy } from '@/hooks/use-fuzzy';
import { fuzzyQueryUser } from '@/api/auth-manage/user/index';
import _ from 'lodash-es';
import { defineComponent, PropType, reactive, ref } from 'vue';
import { IManageQueryListChildrenItem, IManageUpdatePMReq, serviceBasicInfoRes } from '@/api/project-service/type.d';
import { FIRST_PEOPLE_ENUM, HANDLE_SERVICE_TYPE_LIST } from '@/constant/project-service/index';
import { singleEdit,
  manageSelectAllServiceBasicInfo,
  queryAllParentProject,
} from '@/api/project-service/index';

export interface IManageUpdatePMReqExpand extends IManageUpdatePMReq {
  firstHeadOfBackend: string;
  secondHeadOfBackend: string;
  firstHeadOfBackendCode: string;
  secondHeadOfBackendCode: string;

}

export default defineComponent({
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object as PropType<IManageQueryListChildrenItem>,
      default: () => {},
    },

  },
  emits: ['update:modelValue', 'success', 'cancel'],
  setup(props, { emit }) {
    const formRef = ref<typeof ElForm>();
    const projectNames = ref();
    const isDisabled = ref<boolean>(true);
    const servicesList = ref<serviceBasicInfoRes>({} as serviceBasicInfoRes);
    const formData = reactive<IManageUpdatePMReqExpand>({
      managementId: '',
      projectName: '',
      domainName: '',
      firstLevelMenu: '',
      secondLevelMenu: '',
      serviceType: '',
      serviceName: '',
      headOfDevelopment: '',
      secondHeadOfDevelopment: '',
      headOfTest: '',
      secondHeadOfTest: '',
      firstHeadOfBackend: '',
      secondHeadOfBackend: '',
      firstHeadOfBackendCode: '',
      secondHeadOfBackendCode: '',
    });

    // 模糊输入负责人名字
    const {
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
    } = useFuzzy<any, UserItem[]>({
      params: { keyword: '' },
      keywordKey: 'keyword',
      API: fuzzyQueryUser,
      beforeRequest(_param, query) {
        return query;
      },
      beforeResponse(res) {
        return res.data?.map((user: UserItem) => {
          const { name: label, userId: value } = user;
          return { ...user, label, value };
        });
      },
    });
    const handleChangeUser = (userInfo: UserItem, key:FIRST_PEOPLE_ENUM) => {
      switch (key) {
        case FIRST_PEOPLE_ENUM.DEVELOPMENT_FIRST:
          formData.headOfDevelopment = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            formData.headOfDevelopment = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.DEVELOPMENT_SECOND:
          formData.secondHeadOfDevelopment = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            formData.secondHeadOfDevelopment = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.TEST_FIRST:
          formData.headOfTest = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            formData.headOfTest = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.TEST_SECOND:
          formData.secondHeadOfTest = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            formData.secondHeadOfTest = '';
          }
          break;
        default: break;
      }
    };
    // 重置表单
    const resetVar = () => {
      formRef.value?.resetFields();
      formData.domainName = '';
      formData.projectName = '';
      formRef.value?.clearValidate();
    };
    const handleOpen = () => {
      const {
        editData: {
          managementId,
          projectName,
          domainName,
          firstLevelMenu,
          secondLevelMenu,
          serviceType,
          serviceName,
          headOfDevelopment,
          secondHeadOfDevelopment,
          headOfTest,
          secondHeadOfTest,
          firstHeadOfBackend,
          firstHeadOfBackendCode,
          secondHeadOfBackend,
          secondHeadOfBackendCode,
        },
      } = props;
      formData.projectName = projectName;
      formData.domainName = domainName;
      formData.firstLevelMenu = firstLevelMenu;
      formData.managementId = managementId;
      formData.secondLevelMenu = secondLevelMenu;
      formData.serviceType = serviceType;
      formData.serviceName = serviceName;
      formData.headOfDevelopment = headOfDevelopment;
      formData.secondHeadOfDevelopment = secondHeadOfDevelopment;
      formData.headOfTest = headOfTest;
      formData.secondHeadOfTest = secondHeadOfTest;
      formData.firstHeadOfBackend = `${firstHeadOfBackend}${firstHeadOfBackendCode}`;
      formData.secondHeadOfBackend = `${secondHeadOfBackend}${secondHeadOfBackendCode}`;
    };

    const { visible } = useDialogVisible(props, emit);

    // 查询项目名称
    const handleSearchProject = async () => {
      const { data } = await queryAllParentProject();
      projectNames.value = data.map((item) => {
        return item;
      });
      console.log(projectNames, 'projectNames');
    };
    const handleSelectProjectItem = async (val: string) => {
      console.log(val, 'val');
      if (projectNames.value.includes(val)) {
        isDisabled.value = true;
      } else {
        isDisabled.value = false;
      }
      projectNames.value.forEach((v: any) => {
        if (v.projectName === val) {
          formData.domainName = v.domainName;
          isDisabled.value = true;
        }
      });
    };
    // 查询后端服务
    const handleSearchService = async () => {
      const { data } = await manageSelectAllServiceBasicInfo();
      if (!data) {
        servicesList.value = [];
        return;
      }
      servicesList.value = data;
    };
    // 处理选中服务，回显对应后端负责人
    const handleSelectServiceItem = (val: any) => {
      const res = servicesList.value.filter((item) => {
        return item.serviceName === val;
      });
      console.log(res[0], 'res');
      formData.firstHeadOfBackend = `${res[0]?.firstHeadOfBackend}(${res[0]?.firstHeadOfBackendCode})`;
      formData.secondHeadOfBackend = `${res[0]?.secondHeadOfBackend}(${res[0]?.secondHeadOfBackendCode})`;
      if (res[0]?.firstHeadOfBackend === '') {
        formData.firstHeadOfBackend = '';
      }
      if (res[0]?.secondHeadOfBackend === '') {
        formData.secondHeadOfBackend = '';
      }
    };
    const handleClear = () => {
      formData.secondHeadOfBackend = '';
      formData.firstHeadOfBackend = '';
    };
    const handleConfirm = async () => {
      try {
        const isValid = await formRef.value?.validate();
        if (isValid) {
          const requestParam = _.cloneDeep(formData);
          requestParam.managementId = props.editData.managementId;
          console.log(requestParam, 'requestParam');
          await singleEdit(requestParam);
          ElMessage.success('操作成功');
          emit('success');
          resetVar();
          visible.value = false;
        }
      } catch (err) {
        console.log(err);
      }
    };
    const handleClose = () => {
      emit('cancel');
      visible.value = false;
    };

    return {
      formData,
      HANDLE_SERVICE_TYPE_LIST,
      visible,
      handleOpen,
      handleConfirm,
      formRef,
      handleClose,
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
      FIRST_PEOPLE_ENUM,
      handleChangeUser,
      handleSearchService,
      servicesList,
      handleSelectServiceItem,
      handleSearchProject,
      isDisabled,
      projectNames,
      handleSelectProjectItem,
      handleClear,
    };
  },

});
